"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = createUniqueArray;
/**
 * Takes an array and returns a new array with only unique values
 * @param arr
 * @returns
 */
function createUniqueArray(arr) {
    return Array.from(new Set(arr));
}
//# sourceMappingURL=createUniqueArray.js.map